import { LandingHero } from '~/modules/LandingHero';
import { type ComponentLoaderContext } from '~/types';
import { type LandingPageSectionName, type SectionMap } from '~/types/template';

import { renderComponents } from '../../utils/renderComponents';
import { Section } from '../Section/Section';

import styles from './LandingPageTemplate.module.css';

type LandingPageTemplateProps = {
  backgroundImage?: string;
  componentLoaderContext: ComponentLoaderContext;
  ctaSubText?: string[];
  ctaText?: string;
  ctaUrl?: string;
  gtmId: string;
  h1Heading?: string;
  introText?: string;
  sections: Pick<SectionMap, LandingPageSectionName>;
};

export const LandingPageTemplate = ({
  backgroundImage,
  componentLoaderContext,
  ctaSubText,
  ctaText,
  ctaUrl,
  gtmId,
  h1Heading,
  introText,
  sections,
}: LandingPageTemplateProps) => {
  const { currentPathWithRepub } = componentLoaderContext;

  return (
    <div
      className={styles.outerWrapper}
      style={backgroundImage ? ({ '--bg-image': `url(${backgroundImage})` } as React.CSSProperties) : undefined}
    >
      <div className={styles.innerContainer}>
        <Section
          ariaLabel="Landing Page Header"
          className={styles.top}
          content={renderComponents({ components: sections.top ?? null, componentLoaderContext, gtmId })}
          dataTestId="landing-page-top"
          id="landing-page-top"
          show
        />
        {h1Heading && ctaText && ctaUrl && introText && (
          <LandingHero
            ctaSubText={ctaSubText}
            ctaText={ctaText}
            ctaUrl={ctaUrl}
            currentPathWithRepub={currentPathWithRepub}
            h1Heading={h1Heading}
            introText={introText}
          />
        )}
        <div className={styles.centerGrid}>
          <Section
            ariaLabel="Landing Page Left Section"
            className={styles.centerLeft}
            content={renderComponents({ components: sections.centerLeft ?? null, componentLoaderContext, gtmId })}
            dataTestId="landing-page-center-left"
            id="landing-page-center-left"
            show
          />
          <Section
            ariaLabel="Landing Page Right Section"
            className={styles.centerRight}
            content={renderComponents({ components: sections.centerRight ?? null, componentLoaderContext, gtmId })}
            dataTestId="landing-page-center-right"
            id="landing-page-center-right"
            show
          />
        </div>
        <Section
          ariaLabel="Landing Page Center Bottom"
          className={styles.centerBottom}
          content={renderComponents({ components: sections.centerBottom ?? null, componentLoaderContext, gtmId })}
          dataTestId="landing-page-center-bottom"
          id="landing-page-center-bottom"
          show
        />
      </div>
      <Section
        ariaLabel="Landing Page Footer"
        className={styles.bottom}
        content={renderComponents({ components: sections.bottom ?? null, componentLoaderContext, gtmId })}
        dataTestId="landing-page-bottom"
        id="landing-page-bottom"
        show
      />
    </div>
  );
};
